const data = {
  id: 1,
  title: 'Choose odd one out.',
  subTitle: 'Chọn từ khác với các từ còn lại.',
  question: '',
  answers: [
    { id: 1, answer: 'wardrobe', isCorrect: false },
    { id: 2, answer: 'sofa', isCorrect: false },
    { id: 3, answer: 'cabinet', isCorrect: false },
    { id: 4, answer: 'market', isCorrect: true },
  ],
  settings: {
    answers: {
      direction: 'vertical',
    },
  },
};

export default data;
